import React, { Component } from 'react'
import FormContainer from '../../components/formbuilder/container/FormContainer';

export default class InternalFormSubscription extends Component {
  render() {
    return (
        <div>
            &nbsp;
            <FormContainer idForm={this.props.params.id} {...this.props} interno/>
            &nbsp;
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/view/internal_forms/InternalFormSubscription.js